import React, { useState, useEffect } from 'react';
import './HomePage.css';
import slideshow1 from './slideshow/slideshow (1).png';
import slideshow2 from './slideshow/slideshow (2).png';
import slideshow3 from './slideshow/slideshow (3).png';
import slideshow4 from './slideshow/slideshow (4).png';
import slideshow5 from './slideshow/slideshow (5).png';
import slideshow6 from './slideshow/slideshow (6).png';
import slideshow8 from './slideshow/slideshow (8).png';
import slideshow10 from './slideshow/slideshow (10).png';
import slideshow11 from './slideshow/slideshow (11).png';
import slideshow12 from './slideshow/slideshow (12).png';
import slideshow13 from './slideshow/slideshow (13).png';
import slideshow14 from './slideshow/slideshow (14).png';
import slideshow15 from './slideshow/slideshow (15).png';
import slideshow16 from './slideshow/slideshow (16).png';
import product2 from './homepage-products/Products (2).png';
import product3 from './homepage-products/Products (3).png';
import product6 from './homepage-products/Products (6).png';
import product8 from './homepage-products/Products (8).png';
import product10 from './homepage-products/Products (10) test.png';
import product11 from './homepage-products/Products (11).png';
import product16 from './homepage-products/Products (16).png';


const App = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const slides = document.querySelectorAll('.slides');
        slides.forEach((slide, index) => {
            slide.style.display = index === currentSlide ? 'block' : 'none';
        });
    }, [currentSlide]);

    useEffect(() => {
        const interval = setInterval(() => {
            showSlide(currentSlide + 1);
        }, 3000); 

        return () => clearInterval(interval);
    }, [currentSlide]);


    const showSlide = (index) => {
        const slides = document.querySelectorAll('.slides');
        if (index >= slides.length) {
            setCurrentSlide(0);
        } else if (index < 0) {
            setCurrentSlide(slides.length - 1);
        } else {
            setCurrentSlide(index);
        }
    };

    return (
        <div className="homepage-container">
            <div className="row row1">
                <div className="slideshow-container">
                  <div className="slides fade">
                        <a className="prev" onClick={() => showSlide(currentSlide - 1)}>&#10094;</a>
                        <img src={slideshow1} alt="Slide 1" />
                        <a className="next" onClick={() => showSlide(currentSlide + 1)}>&#10095;</a>
                    </div>
                    <div className="slides fade">
                        <a className="prev" onClick={() => showSlide(currentSlide - 1)}>&#10094;</a>
                        <img src={slideshow2} alt="Slide 2" />
                        <a className="next" onClick={() => showSlide(currentSlide + 1)}>&#10095;</a>
                    </div>
                    <div className="slides fade">
                        <a className="prev" onClick={() => showSlide(currentSlide - 1)}>&#10094;</a>
                        <img src={slideshow3} alt="Slide 3" />
                        <a className="next" onClick={() => showSlide(currentSlide + 1)}>&#10095;</a>
                    </div>
                    <div className="slides fade">
                        <a className="prev" onClick={() => showSlide(currentSlide - 1)}>&#10094;</a>
                        <img src={slideshow4} alt="Slide 4" />
                        <a className="next" onClick={() => showSlide(currentSlide + 1)}>&#10095;</a>
                    </div>
                    <div className="slides fade">
                        <a className="prev" onClick={() => showSlide(currentSlide - 1)}>&#10094;</a>
                        <img src={slideshow5} alt="Slide 5" />
                        <a className="next" onClick={() => showSlide(currentSlide + 1)}>&#10095;</a>
                    </div>
                    <div className="slides fade">
                        <a className="prev" onClick={() => showSlide(currentSlide - 1)}>&#10094;</a>
                        <img src={slideshow6} alt="Slide 6" />
                        <a className="next" onClick={() => showSlide(currentSlide + 1)}>&#10095;</a>
                    </div>
                    <div className="slides fade">
                        <a className="prev" onClick={() => showSlide(currentSlide - 1)}>&#10094;</a>
                        <img src={slideshow8} alt="Slide 8" />
                        <a className="next" onClick={() => showSlide(currentSlide + 1)}>&#10095;</a>
                    </div>
                    <div className="slides fade">
                        <a className="prev" onClick={() => showSlide(currentSlide - 1)}>&#10094;</a>
                        <img src={slideshow10} alt="Slide 10" />
                        <a className="next" onClick={() => showSlide(currentSlide + 1)}>&#10095;</a>
                    </div>
                    <div className="slides fade">
                        <a className="prev" onClick={() => showSlide(currentSlide - 1)}>&#10094;</a>
                        <img src={slideshow11} alt="Slide 11" />
                        <a className="next" onClick={() => showSlide(currentSlide + 1)}>&#10095;</a>
                    </div>
                    <div className="slides fade">
                        <a className="prev" onClick={() => showSlide(currentSlide - 1)}>&#10094;</a>
                        <img src={slideshow12} alt="Slide 12" />
                        <a className="next" onClick={() => showSlide(currentSlide + 1)}>&#10095;</a>
                    </div>
                    <div className="slides fade">
                        <a className="prev" onClick={() => showSlide(currentSlide - 1)}>&#10094;</a>
                        <img src={slideshow13} alt="Slide 13" />
                        <a className="next" onClick={() => showSlide(currentSlide + 1)}>&#10095;</a>
                    </div>
                    <div className="slides fade">
                        <a className="prev" onClick={() => showSlide(currentSlide - 1)}>&#10094;</a>
                        <img src={slideshow14} alt="Slide 14" />
                        <a className="next" onClick={() => showSlide(currentSlide + 1)}>&#10095;</a>
                    </div>
                    <div className="slides fade">
                        <a className="prev" onClick={() => showSlide(currentSlide - 1)}>&#10094;</a>
                        <img src={slideshow15} alt="Slide 15" />
                        <a className="next" onClick={() => showSlide(currentSlide + 1)}>&#10095;</a>
                    </div>
                    <div className="slides fade">
                        <a className="prev" onClick={() => showSlide(currentSlide - 1)}>&#10094;</a>
                        <img src={slideshow16} alt="Slide 16" />
                        <a className="next" onClick={() => showSlide(currentSlide + 1)}>&#10095;</a>
                    </div>
                </div>
            </div>

            <div className="row row2">
              <div className="column21">
              <h2 className="glow-text1">Welcome to Connoisseur Audio</h2><p className="singapore-text"><u>Singapore</u></p>
              </div>
                <div className="column22">                    
                <p>We specialize in High-End Analog Products and Accessories.</p> 
                <p>Our Tonearms, Record Cleaning Machines, Amplifiers, Speakers and Accessories</p>
                <p>will enhance the listening experience for customers with all levels of Analog Systems.</p> 
                <p>No effort will be spared to create the best possible Analog Playback System.</p> 
                <p>We believe that our line of products are not only 
                    <span class="red"> S</span>tate <span class="red">O</span>f <span class="red">T</span>he <span class="red">A</span>rt 
                    but also World Class.
                </p>
 
                </div>
            </div>

            <div className="row row3">
            <div className="column31">
                <h2 className="glow-text2">Featured Brands</h2>
            </div>

            <div className="image-row">
                <div className="image-container"><img src={product8} alt="Product 8" className="image"/><div className="overlay"></div></div>
                <div className="image-container"><img src={product16} alt="Product 16" className="image"/><div className="overlay"></div></div>
                {/* <div className="image-container"><img src={product10} alt="Product 10" className="image"/><div className="overlay"></div></div> */}
                <div className="image-container"><img src={product3} alt="Product 3" className="image"/><div className="overlay"></div></div>
            </div>
            <div className="image-row">
                <div className="image-container"><img src={product2} alt="Product 2" className="image"/><div className="overlay"></div></div>
                <div className="image-container"><img src={product11} alt="Product 11" className="image"/><div className="overlay"></div></div>
                <div className="image-container"><img src={product6} alt="Product 6" className="image"/><div className="overlay"></div></div>
            </div>
                </div>

            </div>
    );
};

export default App;
